<template lang="html">
  <b-container>
    <b-row class="mb-4">
      <b-col v-if="!has_coupon" md="12">
        <h1 class="text-center">Soundslides 3 pricing</h1>
      </b-col>
      <b-col v-else md="12">
        <h1 class="text-center">
          <span class="">
            Subscribe now and get
            {{ $store.state.global_coupon.percentage_off }}% off!
          </span>
        </h1>
      </b-col>
    </b-row>
    <b-row v-if="has_stripe_error" class="mb-4">
      <b-col md="6" offset-md="3" class="alert alert-info">
        <h3>
          <v-icon name="exclamation-triangle" class="mr-2" />
          Payment Processing Error
        </h3>
        <p class="mt-3">Your payment failed with the following message:</p>
        <code class="text-dark">
          {{ $store.state.user_doc.stripe_error_result.message }}
        </code>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <div v-if="!displayStandardPricing" class="col-md-4 mb-4">
        <h2 class="mt-5">Monthly billing</h2>
      </div>
      <div v-if="displayStandardPricing" class="col-md-4">
        <div class="card mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Standard</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              $3 <small class="text-muted">a month</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Create and edit new shows online</li>
              <li>Built-in hosting for 10 shows</li>
              <li>HD Video export</li>
              <li>Import your Soundslides 1.x shows</li>
              <li>Email support</li>
            </ul>
            <StripePlan plan_slug="standard_monthly" class="plan-button" />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Plus</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              $5 <small class="text-muted">a month</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Create and edit new shows online</li>
              <li><mark>Built-in hosting for 50 shows</mark></li>
              <li>HD Video export</li>
              <li>Import your Soundslides 1.x shows</li>
              <li>Priority email support</li>
            </ul>
            <StripePlan plan_slug="plus_monthly" class="plan-button" />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Premium</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              $10 <small class="text-muted">a month</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Create and edit new shows online</li>
              <li><mark>Unlimited show hosting</mark></li>
              <li>HD Video export</li>
              <li>Import your Soundslides 1.x shows</li>
              <li>Priority email support</li>
            </ul>
            <StripePlan plan_slug="premium_monthly" class="plan-button" />
          </div>
        </div>
      </div>
    </b-row>

    <b-row class="mt-5">
      <div v-if="!displayStandardPricing" class="col-md-4 mb-4">
        <h2 class="mt-5">Annual billing</h2>
        <p class="mt-3">
          Save of up to <mark>40% per year</mark> with annual billing.
        </p>
      </div>
      <div v-if="displayStandardPricing" class="col-md-4">
        <div class="card mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Standard</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              <span :class="{ 'strike-it': has_coupon }">
                $19 <small class="text-muted">a year</small>
              </span>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Create and edit new shows online</li>
              <li>Built-in hosting for 10 shows</li>
              <li>HD Video export</li>
              <li>Import your Soundslides 1.x shows</li>
              <li>Email support</li>
            </ul>
            <StripePlan
              :coupon_override="has_coupon"
              plan_slug="standard"
              class="plan-button"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Plus</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              <span :class="{ 'strike-it': has_coupon }">
                $39 <small class="text-muted">a year</small>
              </span>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Create and edit new shows online</li>
              <li><mark>Built-in hosting for 50 shows</mark></li>
              <li>HD Video export</li>
              <li>Import your Soundslides 1.x shows</li>
              <li>Priority email support</li>
            </ul>
            <StripePlan
              :coupon_override="has_coupon"
              plan_slug="plus"
              class="plan-button"
            />
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Premium</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              <span :class="{ 'strike-it': has_coupon }">
                $69 <small class="text-muted">a year</small>
              </span>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Create and edit new shows online</li>
              <li><mark>Unlimited show hosting</mark></li>
              <li>HD Video export</li>
              <li>Import your Soundslides 1.x shows</li>
              <li>Priority email support</li>
            </ul>
            <StripePlan
              :coupon_override="has_coupon"
              plan_slug="premium"
              class="plan-button"
            />
          </div>
        </div>
      </div>
    </b-row>

    <b-row v-if="!has_coupon" class="mb-5 mt-5">
      <b-col v-if="displayStandardPricing" md="12">
        <h3 v-if="payment_interval == 'annual'" class="text-center">
          View
          <b-link
            @click="payment_interval = 'monthly'"
            v-text="'monthly billing'"
          />
          options.
        </h3>
        <h3 v-else class="text-center">
          See
          <b-link
            @click="payment_interval = 'annual'"
            v-text="'annual billing'"
          />
          options for savings of up to 40% per year.
        </h3>
      </b-col>
    </b-row>

    <b-row v-if="has_coupon" class="mb-5">
      <b-col md="12">
        <p class="text-center smaller mt-4">
          <mark>
            Coupon applies to initial annual subscription. Regular price applies
            on renewal.
          </mark>
        </p>
      </b-col>
    </b-row>

    <!--
    <b-row class="mt-3">
      <b-col md="8" offset-md="2" class="alert alert-info">
        <h4>Have more specific requirements? Need more?</h4>
        <p>
          Contact us for enterprise bandwidth pricing, as well as options for
          direct publication to your Amazon S3, SFTP, Microsoft Azure, or Google
          Cloud Storage accounts. API and post-publication webhooks available.
        </p>
        <p>
          <a href="mailto:info@tungite.com">Contact us</a> with your specific
          use case.
        </p>
      </b-col>
    </b-row>
    -->

    <b-row v-if="false" class="mt-4 alert alert-secondary">
      <b-col md="4">
        <h4>Soundslides legacy services</h4>
        <p>
          We are the official maintainer of services for Soundslides 1 users. We
          literally wrote the app way back in 2005.
        </p>
        <p>
          Need help bulk-migrating all of your shows over to a non-Flash format?
          We can help.
        </p>
      </b-col>
      <div class="col-md-4">
        <div class="card card-short mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Free</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              $0
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Import your Soundslides 1.x shows</li>
              <li><b>DV size only (720x480)</b></li>
              <li>Converted eventually</li>
              <li>Paid accounts go first</li>
              <li>Email support</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card-short mb-4 shadow-sm">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal">Basic</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title">
              $12 <small class="text-muted">annually</small>
            </h1>
            <ul class="list-unstyled mt-3 mb-4">
              <li>Import your Soundslides 1.x shows</li>
              <li>HD Video export</li>
              <li>Built-in hosting for 10 shows</li>
              <li>
                <mark>
                  For users that don't need the Soundslides 3 online editor
                </mark>
              </li>
              <li>Email support</li>
            </ul>
            <StripePlan plan_slug="basic" class="plan-button" />
          </div>
        </div>
      </div>
    </b-row>
    <b-row v-if="false">
      <b-col md="8" offset-md="2" class="mt-5">
        <h4 class="mb-4">Frequently asked questions</h4>
        <!--
        <h5>
          What happens if I exceed the Basic or Standard plan's monthly views
          threshold?
        </h5>
        <p>
          There’s a one-month grace period for overages. If you go over your
          limit one month because your slideshow has become wildly popular, then
          that’s cool with us. We're happy for you! If it happens twice, you’ll
          need to upgrade to a plan with unlimited views.
        </p>
      -->
        <h5>What happens to my shows if I discontinue my account?</h5>
        <p>
          If you discontinue your paid subscription, your account will
          automatically downgrade to a Free account. Your shows will continue to
          be hosted but traffic will be limited to an available
          <em>“free users”</em> bandwidth pool. You won't be able to edit your
          shows without upgrading to a paid account. Your show files will not be
          deleted as long as resources are available, unless you delete them
          yourself.
        </p>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import StripePlan from "@/components/StripePlan.vue";

export default {
  name: "PlanSignup",
  filters: {},
  components: {
    StripePlan
  },
  data() {
    return {
      payment_interval: "monthly",
      valid_c_codes: ["ca50", "bd50", "gt50", "ro50"],
      displayStandardPricing: false
    };
  },
  computed: {
    has_stripe_error() {
      return (
        "error" in this.$route.query && this.$store.state.user_doc.stripe_error
      );
    },
    has_coupon() {
      if (this.valid_c_codes.includes(this.$route.params.coupon_id)) {
        return true;
      }
      return false;
    }
  },
  mounted() {
    if (this.has_coupon) {
      this.payment_interval = "annual";
    }
  },
  methods: {}
};
</script>

<style lang="css" scoped>
.card {
  min-height: 430px;
  padding-bottom: 30px;
}
.card-short {
  min-height: 430px;
}
.plan-button {
  position: absolute;
  bottom: 16px;
}

.strike-it {
  background: linear-gradient(
    to left top,
    transparent 48%,
    #ec6e41 49%,
    #ec6e41 50%,
    transparent 51%
  );
}
.smaller {
  font-size: 0.9em;
}
</style>
